// Set a cookie
export const setCookie = (name: string, value: string, days?: number) => {
  const expirationDate = new Date();
  if (days) {
    expirationDate.setDate(expirationDate.getDate() + days);
  }

  const cookieValue =
    encodeURIComponent(value) +
    (days ? `; expires=${expirationDate.toUTCString()}` : "");

  document.cookie = `${name}=${cookieValue}; path=/; SameSite=Strict;`;
};

// Get a cookie by name
export const getCookie = (name: string) => {
  const cookies = document.cookie.split(";");
  const foundCookie = cookies.find((cookie) =>
    cookie.trim().startsWith(`${name}=`),
  );
  return foundCookie
    ? decodeURIComponent(foundCookie.trim().substring(name.length + 1))
    : null;
};

// Remove a cookie by name
export const removeCookie = (name: string) => {
  setCookie(name, "", -1);
};
